export const showErrorMessage = (title, message, duration = 10000) => {
    Mobi2Go.UI.centeredAlert({
        title: title,
        body: message,
        temp: true,
        temp_duration: duration,
    });
};
